import { LocalStorageService } from 'src/app/core/localstorage.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatTableExporterModule } from 'mat-table-exporter';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

import { AppComponent } from './app.component';
import { HeaderComponent } from './utility/header/header.component';
import { FooterComponent } from './utility/footer/footer.component';
import { SidebarComponent } from './utility/sidebar/sidebar.component';
import { MaterialModule } from './material/material.module';
import { InterceptorService } from './services/interceptor.service';
import { ClientComponent } from './client/client.component';
import { RegisteredClientComponent } from './registered-client/registered-client.component';
import { LoginComponent } from './login/login.component';
import { AdminpanelComponent } from './adminpanel/adminpanel.component';
import { ToastrModule } from 'ngx-toastr';
import { BackendClientRegistrationComponent } from './backend-client-registration/backend-client-registration.component';
import { PatientListComponent } from './patient-list/patient-list.component';
import { ScopesListComponent } from './scopes-list/scopes-list.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { BackendClientComponent } from './backend-client/backend-client.component';
import { NoContentComponent } from './no-content/no-content.component';
import { DialogboxComponent } from './dialogbox/dialogbox.component';
import { ScopePopupComponent } from './authentication/scope-popup/scope-popup.component';
import {
  MatDialogModule,
  MatDialogRef,
  MatIconModule,
  MatTableModule,
  MAT_DIALOG_DATA,
} from '@angular/material';
import { DatePipe } from '@angular/common';
import { LoaderComponent } from './utility/loader/loader.component';
import { ApiSpecificationsComponent } from './api-specifications/api-specifications.component';
import { HomePageComponent } from './home-page/home-page.component';
import { NavBarComponent } from './utility/nav-bar/nav-bar.component';
import { MatToolbarModule, MatButtonModule } from '@angular/material';
import { RegisteredAppsComponent } from './registered-apps/registered-apps.component';
import { AuthGuard } from './core/auth.gaurd';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserFormComponent } from './user-management/user-form/user-form.component';
import { DataService } from './services/data.service';
import { LaunchAppDialogComponent } from './launch-app-dialog/launch-app-dialog.component';
import {
  AppRequestsComponent,
  confirmationDialog,
} from './app-requests/app-requests.component';
import { ErrorMessageComponent } from './utility/error-message/error-message';
import { OauthTutorialComponent } from './oauth-tutorial/oauth-tutorial.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { UserProfileComponent } from './user-management/user-profile/user-profile.component';
import { UserDialogboxComponent } from './user-management/user-dialogbox/user-dialogbox.component';
import { TermsComponent } from './terms/terms.component';
import { FooterCommonComponent } from './utility/footer-common/footer-common.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SoftwareComponentsComponent } from './software-components/software-components.component';
import { MandatoryDisclosureComponent } from './mandatory-disclosure/mandatory-disclosure.component';
import { EndpointsComponent } from './endpoints/endpoints.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ClientComponent,
    RegisteredClientComponent,
    LoginComponent,
    AdminpanelComponent,
    BackendClientRegistrationComponent,
    PatientListComponent,
    ScopesListComponent,
    AuthenticationComponent,
    BackendClientComponent,
    NoContentComponent,
    DialogboxComponent,
    ScopePopupComponent,
    LoaderComponent,
    ApiSpecificationsComponent,
    HomePageComponent,
    NavBarComponent,
    RegisteredAppsComponent,
    UserManagementComponent,
    UserFormComponent,
    AppRequestsComponent,
    LaunchAppDialogComponent,
    confirmationDialog,
    ErrorMessageComponent,    
    UserDialogboxComponent,
    OauthTutorialComponent,
    VerifyEmailComponent,
    UserProfileComponent,
    TermsComponent,
    FooterCommonComponent,
    PrivacyPolicyComponent,
    SoftwareComponentsComponent,
    MandatoryDisclosureComponent,
    EndpointsComponent,
  ],
  entryComponents: [
    ScopePopupComponent,
    UserFormComponent,
    DialogboxComponent,
    ScopePopupComponent,
    LaunchAppDialogComponent,
    LoginComponent,
    AppRequestsComponent,
    confirmationDialog,
    UserDialogboxComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    MatTableExporterModule,
    MatIconModule,
    Ng4LoadingSpinnerModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    MatToolbarModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule,
    NgxMaskModule.forRoot()
  ],
  providers: [
    AuthGuard,
    DataService,
    LocalStorageService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
